export var RibbonShape;
(function (RibbonShape) {
    RibbonShape["Rectangle"] = "rectangle";
    RibbonShape["Square"] = "square";
})(RibbonShape || (RibbonShape = {}));
//# sourceMappingURL=types.js.map